import React, { Fragment, useEffect, useState } from 'react';
import { DialogContent, DialogOverlay } from '@reach/dialog';
import { styled, css, keyframes } from 'styled-components';
import { useMobileDialogDispatch, useMobileDialogState } from './MobileDialogContext';
import { Colors } from '../../../../play-core/styles/Colors';
import { zIndex } from '../../../../play-core/styles/z-index';
import { useOneWayTimeoutToggle } from '../Collapsible/use-one-way-timeout-toggle';
import { jsx as _jsx } from "react/jsx-runtime";
const transitionDuration = 300;
export const MobileDialog = ({
  dialogId,
  isOpen,
  title,
  onClose,
  children
}) => {
  const dispatch = useMobileDialogDispatch();
  const state = useMobileDialogState();
  const [isFirst, setIsFirst] = useState(state.dialogs.length === 0);
  const [isRegistered, setRegistered] = useState(false);
  const displayDialogs = !(!isFirst && state.closeAll);
  const show = useOneWayTimeoutToggle([true, false], !isOpen, transitionDuration);
  useEffect(() => {
    if (isOpen && !isRegistered) {
      setIsFirst(state.dialogs.length === 0);
      dispatch({
        type: 'register',
        dialogId
      });
      setRegistered(true);
    }
    if (isRegistered && (!state.dialogs.includes(dialogId) || !isOpen)) {
      dispatch({
        type: 'unregister',
        dialogId
      });
      setRegistered(false);
      onClose();
    }
  }, [dialogId, isOpen, isRegistered, dispatch, state.dialogs, onClose]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: show && displayDialogs && /*#__PURE__*/_jsx(StyledDialogOverlay, {
      onDismiss: onClose,
      children: /*#__PURE__*/_jsx(DialogContentWrapper, {
        isFirst: isFirst,
        isOpen: isOpen,
        children: /*#__PURE__*/_jsx(StyledDialogContent, {
          "data-is-open": isOpen,
          "aria-label": title,
          children: children
        })
      })
    })
  });
};
const fadeInFirst = keyframes(["0%{transform:translateY(100vh);}100%{transform:translateY(0);}"]);
const fadeOutFirst = keyframes(["0%{transform:translateY(0);}100%{transform:translateY(100vh);}"]);
const fadeInDefault = keyframes(["0%{transform:translateX(100vw);}100%{transform:translateX(0);}"]);
const fadeOutDefault = keyframes(["0%{transform:translateX(0);}100%{transform:translateX(100vw);}"]);
const StyledDialogOverlay = styled(DialogOverlay).withConfig({
  displayName: "MobileDialog__StyledDialogOverlay",
  componentId: "sc-265vs4-0"
})(["z-index:", ";&[data-reach-dialog-overlay]{background:transparent;}"], zIndex.dialog);
const DialogContentWrapper = styled.div.withConfig({
  displayName: "MobileDialog__DialogContentWrapper",
  componentId: "sc-265vs4-1"
})(["position:fixed;top:0;right:0;bottom:0;left:0;", ";"], ({
  isOpen
}) => isOpen ? fadeIn : fadeOut);
const fadeIn = css(["animation:", " ", "ms ease-in-out forwards;"], ({
  isFirst
}) => isFirst ? fadeInFirst : fadeInDefault, transitionDuration);
const fadeOut = css(["animation:", " ", "ms ease-in-out forwards;"], ({
  isFirst
}) => isFirst ? fadeOutFirst : fadeOutDefault, transitionDuration);
const StyledDialogContent = styled(DialogContent).withConfig({
  displayName: "MobileDialog__StyledDialogContent",
  componentId: "sc-265vs4-2"
})(["&[data-reach-dialog-content]{position:fixed;top:0;right:0;bottom:0;left:0;width:100vw;margin:0;padding:0;background-color:", ";}"], Colors.GREY_1a1a1a);